module.exports = __webpack_public_path__ + "static/media/shop_30_1.a384e414.png";